/**
 * Wybor parametrow oceny: czyste funkcje na liscie z GET /api/sessions/meta/lenses.
 *
 * Wybor jest zbiorem slugow, ale ZAWSZE zapisujemy go w kolejnosci katalogu (czyli metodyki):
 * dzieki temu to, co leci na serwer, nie zalezy od kolejnosci klikniec, a testy porownuja listy
 * wprost. W interfejsie mowimy "parametry"; "soczewka" to wewnetrzna nazwa metodyki.
 */

import { odmien } from "./polski.js";

/** Najmniejszy ksztalt parametru, jakiego potrzebuje wybor (pasuje do ParametrOceny i do WyborSoczewkiDto). */
export interface ParametrDoWyboru {
  slug: string;
  title: string;
}

/** Domyslnie zaznaczone sa wszystkie parametry, ktore serwer oznaczyl jako domyslne (czyli wlaczone). */
export function domyslnyWybor(
  katalog: readonly (ParametrDoWyboru & { domyslnieZaznaczona?: boolean })[],
): string[] {
  return katalog.filter((p) => p.domyslnieZaznaczona !== false).map((p) => p.slug);
}

/** Wybor w kolejnosci katalogu, bez slugow, ktorych w katalogu nie ma (np. po zmianie metodyki). */
export function uporzadkujWybor(wybor: readonly string[], katalog: readonly ParametrDoWyboru[]): string[] {
  const zaznaczone = new Set(wybor);
  return katalog.filter((p) => zaznaczone.has(p.slug)).map((p) => p.slug);
}

/** Wybor po zaznaczeniu albo odznaczeniu jednego parametru. */
export function przelaczParametr(
  wybor: readonly string[],
  slug: string,
  zaznaczony: boolean,
  katalog: readonly ParametrDoWyboru[],
): string[] {
  const zbior = new Set(wybor);
  if (zaznaczony) zbior.add(slug);
  else zbior.delete(slug);
  return uporzadkujWybor([...zbior], katalog);
}

/** Zaznaczone wszystkie, zadne albo czesc - do checkboxa "zaznacz wszystkie" (TB-5). */
export function stanZaznaczeniaWszystkich(
  wybor: readonly string[],
  katalog: readonly ParametrDoWyboru[],
): "wszystkie" | "zadne" | "czesc" {
  const n = uporzadkujWybor(wybor, katalog).length;
  if (n === 0) return "zadne";
  return n === katalog.length ? "wszystkie" : "czesc";
}

/** Zdanie o kosztach wyboru: kazdy parametr to osobne, platne wywolanie modelu. */
export function opisKosztuWyboru(liczba: number): string {
  if (liczba === 0) return "Nic nie zaznaczono - nie ma czego liczyć.";
  const wywolania = odmien(liczba, "płatne wywołanie", "płatne wywołania", "płatnych wywołań");
  return `Zaznaczone parametry to ${liczba} ${wywolania} modelu: każdy parametr liczy się osobno.`;
}
